import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["progress", "achievements", "xp", "tipsViewed", "streak"]

  connect() {
    this.loadProgress()
  }

  async loadProgress() {
    try {
      const response = await fetch('/learning_options/progress', {
        headers: { 'Accept': 'application/json' }
      })
      if (response.ok) {
        const data = await response.json()
        this.updateProgressDisplay(data)
      }
    } catch (e) {
      console.error('Failed to load learning progress:', e)
    }
  }

  updateProgressDisplay(data) {
    if (this.hasXpTarget) {
      this.xpTarget.textContent = data.total_xp || 0
    }
    if (this.hasTipsViewedTarget) {
      this.tipsViewedTarget.textContent = data.tips_viewed || 0
    }
    if (this.hasStreakTarget) {
      this.streakTarget.textContent = data.streak_days || 0
    }
  }

  async refreshAchievements() {
    if (!this.hasAchievementsTarget) return

    try {
      const response = await fetch('/learning_options/achievements', {
        headers: { 'Accept': 'text/html' }
      })
      if (response.ok) {
        const html = await response.text()
        this.achievementsTarget.innerHTML = html
      }
    } catch (e) {
      console.error('Failed to refresh achievements:', e)
    }
  }

  // Called when a new achievement is earned
  showAchievementNotification(achievement) {
    const notification = document.createElement('div')
    notification.className = 'achievement-notification animate__animated animate__bounceIn'
    notification.innerHTML = `
      <div class="achievement-icon" style="color: ${achievement.badge_color}">
        <span class="${achievement.badge_icon}"></span>
      </div>
      <div class="achievement-content">
        <div class="achievement-title">Achievement Unlocked!</div>
        <div class="achievement-name">${achievement.name}</div>
        <div class="achievement-xp">+${achievement.xp_reward} XP</div>
      </div>
    `
    document.body.appendChild(notification)

    // Remove after animation
    setTimeout(() => {
      notification.classList.remove('animate__bounceIn')
      notification.classList.add('animate__fadeOut')
      setTimeout(() => notification.remove(), 500)
    }, 3000)
  }
}
